import type { ClientInput } from '../api/client'

export interface NewClientDraft {
  first_name: string
  last_name: string
  phone: string
  email: string
}

export const emptyClientDraft: NewClientDraft = { first_name: '', last_name: '', phone: '', email: '' }

// newClientErrors checks the whole form at once, so every problem shows
// together instead of one per tap (review 2026-10-14). Every field is
// required (2026-10-16). The API still checks every rule (a phone it can't
// read answers 422 phone).
export function newClientErrors(d: NewClientDraft): Record<string, string> {
  const errors: Record<string, string> = {}
  if (d.first_name.trim() === '') {
    errors.first_name = 'Enter their first name.'
  }
  if (d.last_name.trim() === '') {
    errors.last_name = 'Enter their last name.'
  }
  const phone = d.phone.trim()
  if (phone === '') {
    errors.phone = 'Enter their phone number.'
  } else if (phone.replace(/\D/g, '').length < 7) {
    errors.phone = 'Enter a phone number like 07700 900123.'
  }
  const email = d.email.trim()
  if (email === '') {
    errors.email = 'Enter their email.'
  } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
    errors.email = 'Enter an email like name@example.com.'
  }
  return errors
}

// toClientInput is the request body for a checked draft.
export function toClientInput(d: NewClientDraft): ClientInput {
  return {
    first_name: d.first_name.trim(),
    last_name: d.last_name.trim(),
    phone: d.phone.trim(),
    email: d.email.trim(),
  }
}
